import { useState } from "react"
import ButtonSubmit from "../common/buttonSubmit"
import InputFiled from "../common/inputFiled"
import BoxEmailList from "./boxEmailList";
const BoxEmailService = (props: any) => {
  let emails = props.emails ?? [];

  let disabled = props.disabled ?? false;

  const [email, setEmail] = useState("");
  const [disableButton, setDisableButton] = useState(true);

  const addEmail = () => {
    let emailsArray = Object.assign([], emails);
    emailsArray.push(email);
    props.handelUpdate(emailsArray);
    setEmail("");
    setDisableButton(true);
  }
  const validateEmail = () => {
    if (email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )) {
      setDisableButton(false)
    }
    else {
      setDisableButton(true)
    }

  };

  return (
    <div className="row">
      <div className="col-lg-9">
        <InputFiled disabled={disabled} value={email} handleChange={(e: any) => (setEmail(e), validateEmail())} name="emailService" placeholder="name@mail.com" />
      </div>
      <div className="col-lg-3">
        <ButtonSubmit disabled={disableButton || disabled} handleChange={addEmail} className="w-100" textButton="Aggiungi" spinner={false} />
      </div>
      <div className="col-lg-12">
        <BoxEmailList handelUpdate={props.handelUpdate} emails={emails} />

      </div>
    </div>
  )
}

export default BoxEmailService